import React, { useState, useCallback } from 'react';
import _ from 'lodash';
import { Trans } from '@tools/i18n';
import Box from '@kufox/mui/Box';
import { styled } from '@kufox/mui/emotion';
import px2rem from '@kufox/mui/utils/px2rem';
import AccountLogin from './AccountLogin';
import ScanLogin from './ScanLogin';
import { useLang } from '../hookTool';
import { PHONELOGINTABKEY, ACCOUNTLOGINTABKEY, SCANLOGINTABKEY } from './constants';
import { ga } from '../common/tools';
import { Tabs } from '../components';

const Title = styled.div`
  font-size: ${px2rem(34)};
  line-height: ${px2rem(48)};
  margin-top: 0;
  margin-bottom: ${px2rem(40)};
  font-weight: 700;
`;

const FastClick = styled.div`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${px2rem(14)};
  line-height: ${px2rem(22)};
  & span {
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
  }
`;

function Login(props = {}) {
  const {
    onSuccess = _.noop,
    onForgetPwdClick = _.noop,
    signOrDownClick,
    loginKey,
    classes = {},
    forgetLeft,
    customTitle,
  } = props;

  const { t } = useLang();

  const [tabKey, setTabKey] = useState(loginKey || ACCOUNTLOGINTABKEY);

  const handleTabChange = useCallback(
    (key) => {
      setTabKey(key);
      let gaKey = '';
      if (key === PHONELOGINTABKEY) {
        gaKey = '1';
      } else if (key === ACCOUNTLOGINTABKEY) {
        gaKey = '2';
      } else if (key === SCANLOGINTABKEY) {
        gaKey = '3';
      }
      ga('eleClickCollectionV1', {
        str1: 'KucoinWeb',
        str2: 'KucoinWeb.login',
        str3: 'KucoinWeb.login.SwitchButton',
        str4: `KucoinWeb.login.SwitchButton.${gaKey}`,
      });
    },
    [tabKey],
  );
  const _onForgetPwdClick = () => {
    onForgetPwdClick();
    // 忘记密码
    ga('eleClickCollectionV1', {
      str1: 'KucoinWeb',
      str2: 'KucoinWeb.login',
      str3: 'KucoinWeb.login.forgetS',
      str4: 'KucoinWeb.login.forgetS.1',
    });
  };
  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Box style={{ flex: 1 }}>
        {customTitle || <Title className={classes.title}>{t('login')}</Title>}
        <Tabs defaultKey={tabKey} onChange={handleTabChange}>
          <Tabs.TabPane key={PHONELOGINTABKEY} title={t('login.phone')}>
            {tabKey === PHONELOGINTABKEY ? (
              <AccountLogin
                tabKey={PHONELOGINTABKEY}
                key={PHONELOGINTABKEY}
                onSuccess={onSuccess}
                onForgetPwdClick={_onForgetPwdClick}
                phoneLogin
                forgetLeft={forgetLeft}
              />
            ) : null}
          </Tabs.TabPane>
          <Tabs.TabPane key={ACCOUNTLOGINTABKEY} title={t('login.email')}>
            {tabKey === ACCOUNTLOGINTABKEY ? (
              <AccountLogin
                tabKey={ACCOUNTLOGINTABKEY}
                key={ACCOUNTLOGINTABKEY}
                onSuccess={onSuccess}
                onForgetPwdClick={_onForgetPwdClick}
                forgetLeft={forgetLeft}
              />
            ) : null}
          </Tabs.TabPane>
          <Tabs.TabPane key={SCANLOGINTABKEY} title={t('login.qr')}>
            <ScanLogin tabKey={tabKey} onSuccess={onSuccess} />
          </Tabs.TabPane>
        </Tabs>
      </Box>
      {signOrDownClick ? (
        <Box>
          <FastClick className={classes.fastClick}>
            <Trans i18nKey="fast_signup" ns="entrance">
              Haven’t registered?
              <span
                onClick={() => {
                  signOrDownClick(tabKey);
                }}
              >
                Sign up now
              </span>
            </Trans>
          </FastClick>
        </Box>
      ) : null}
    </Box>
  );
}

export default Login;
